<template>
  <div class="stock-sector-query-view">
    <StockSectorQuery />
  </div>
</template>

<script>
import StockSectorQuery from '@/components/screening/StockSectorQuery.vue'

export default {
  name: 'StockSectorQueryView',
  components: {
    StockSectorQuery
  }
}
</script>

<style scoped>
.stock-sector-query-view {
  padding: 20px;
  flex: 1;
}
</style>
